import noop from 'lodash/noop'

import StatusHandler from 'app/shared-components/StatusHandler'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import useHasPermission from 'app/hooks/useHasPermission'
import {
    ArchiveButton, useArchive, ArchiveConfirmationDialog,
} from 'app/shared-components/Archive'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import {
    QuoteStatus,
} from 'app/enums/label.enums'
import useAccountManagementRoutes from 'app/SkyNetRoutes/hooks/useAccountManagementRoutes'
import request from 'app/requests/Quote/Quote.requests'
import useGetAQuote from '../hooks/useGetAQuote'
import QuoteInformationForm from '../QuoteInformationForm'

import useStyles from './AQuoteOverview.styles'
import RequestedLanes from './RequestedLanes'

const AQuoteOverview = ({
    id,
}: {
    id: number
}) => {
    const {
        AQuotes: AQuotesRoutes,
    } = useAccountManagementRoutes()
    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
    } = useGetAQuote(id)

    const {
        classes,
    } = useStyles()
    const updateAllPermission = useHasPermission(['account_update_all'])

    const archive = useArchive({
        requestParamFn: data?.archived ? request.restore
            : request.archive,
        notificationId: 'QuoteUpdateDto',
        title: 'Quote',
        data,
        redirectionAfterSuccess: generateSkyNetLink({
            domainPath: AQuotesRoutes.path,
        }),
    })

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <>
                <QuoteInformationForm
                    value={data}
                    setValue={noop}
                    showContractBasisLink
                    disabled
                    omitField={[
                        QuoteStatus.CANCELLED,
                        QuoteStatus.CREATED,
                    ].includes(data?.quoteStatus) ? [
                            'customerQuotation',
                            'pricingResponsible',
                        ] : undefined}
                    render={({
                        fields, formData,
                    }) => {
                        return (
                            <DomainObjectForm
                                name="AQuoteInformation"
                                value={formData}
                                fields={fields}
                                disabled
                            />
                        )
                    }}
                />
                <RequestedLanes
                    requestedLanes={data?.requestedLanes}
                    disabled
                    aQuoteId={data?.id}
                />
                {updateAllPermission && data?.quoteStatus === QuoteStatus.CANCELLED && (
                    <>
                        <div className={classes.archiveButton}>
                            <ArchiveButton
                                onClick={archive.handleArchiveRestore}
                                archived={data?.archived}
                            />
                        </div>
                        <ArchiveConfirmationDialog
                            title="Quote"
                            openConfirmDialog={archive.openConfirmDialog}
                            handleClose={archive.handleArchiveRestoreConfirm}
                            archived={data?.archived}
                        />
                    </>
                )}
            </>
        </StatusHandler>
    )
}

export default AQuoteOverview
